
export default {
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  computed: {
    containerStyles() {
      const styles = {}

      styles.background = this.blok.backgroundColor
      styles.color = this.blok.textColor
      styles.borderColor = this.blok.borderColor
      styles.borderStyle = 'solid'
      styles.borderWidth = '2px'

      return styles
    },
  },
}
